module.exports = __webpack_public_path__ + "static/media/torso-mid-back.dffad041.png";